/**
 * @Description //TODO 文件功能说明：全局函数定义
 * @author Zhangbin
 * @date 2021/4/30 16:51
 * @Ver 1.3.1
 * @extends Vue
 */

// 消息 弹窗
import { Notification, MessageBox, Message } from 'element-ui'
/* permission 函数声明 */
import constants from "vant/lib/sku/constants";
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import screenfull from 'screenfull'

export default {
	/**
	 * Json对象的浅拷贝
	 * @param parent  父对象
	 * @param child   子对象
	 * @returns {*|{}}
	 * 返回具有父类属性的新的child对象
	 */
	extendShallow: (parent, child) => {
		child = child || {}
		for(let prop in parent) {
			child[prop] = parent[prop]
		}
		return child
	},

	/**
	 * 数据转换成JSONTree
	 * 1.声明了变量，拿到传参过来的值，注意这里拿到的是string类型，不是对应的值
	 * 2.   v[id]==v[“id”]==v.id
	 idMap数组的下标对应着id为下标的相应json数据
	 a[1]对应着id为1的json数据，以此类推
	 3.  拿到当前遍历的父元素id
	 根据父元素id，判断数组里是否存在这样一条数据
	 存在，就判断父元素是否有子元素数组，若没有就添加一个children数组（传参过来的）
	 把当前元素添加父元素的children数组里
	 不存在，就直接添加到jsonTree里
	 * @param data
	 * @param config
	 */
	dataToTree: (data, config) => {
		var id = config.id || 'id',
			pid = config.pid || 'pid',
			children = config.children || 'children',
			label = config.label || 'label',
			icon = config.icon || 'icon',
			path = config.path || 'path',
			name = config.name || 'name',
			projectType = config.projectType || 'projectType',
			projectCompany = config.projectCompany || 'projectCompany',
			type = config.type || 'type',

			jsonTree = [];
		data.forEach(function(row, index) {
			if(row[id]) row.id = row[id];
			if(row[pid]) row.pid = row[pid];
			if(row[children]) row.children = row[children];
			if(row[label]) row.label = row[label];
			if(row[icon]) row.icon = row[icon];
			if(row[path]) row.path = row[path];
			if(row[name]) row.name = row[name];
			if(row[projectType]) row.projectType = row[projectType];
			if(row[projectCompany]) row.projectCompany = row[projectCompany];
		});
		let dbIndexs = [];
		data.forEach(function(row, index) {
			addToTreeNodeList(data, row, (deleteFlag) => {
				dbIndexs.push(index);
			});
		});

		Object.assign([], dbIndexs).forEach((row, index) => {
			data.splice(row, 1, null);
		});

		Object.assign([], data).forEach((row, index) => {
			if(row) jsonTree.push(row);
		});

		/*data.forEach(function (v) {
		    if (!v.pid || v.pid == '0') jsonTree.push(v);
		});*/

		return jsonTree;
	},

	/**
	 * 下载文件
	 * @param base64
	 * @param name
	 */
	downloadFileByBase64: (base64, name) => {
		let myBlob = dataURLtoBlob(base64)
		let myUrl = URL.createObjectURL(myBlob)
		downloadFile(myUrl, name)
	},
	/**
	 * 根据URL 下载文件
	 *
	 */
	downloadFile: downloadFile,

	// 读取img信息
	readFileImg: readFileImg,
	// url形式回显文本
	getObjectURL: getObjectURL,

	// img url 转换成 base64data
	base64Image: base64Image,

	// 导出Excel表
	exportExcel: exportExcel,

	// 全屏方法
	fullscreen: fullscreen,
	isFullscreen: isFullscreen,
	exitFullscreen: exitFullscreen,

	// 获取路由路径
	getRouterPath: getRouterPath,

	// 解析url参数
	getUrlJson: getUrlJson,

	// 获取XX年XX月最后一天的23:59:59
	getLastDayOfMonth,
	// 获取当月最后一天的23:59:59
	getLastDayOfCurrentMonth,

	// 操作类型：
	OptType: {
		ADD: "add",
		EDIT: "edit",
		DELETE: "delete",
		SEARCH: "search"
	}
}

/**
 * 递归加入子节点
 * @param data
 * @param row
 */
function addToTreeNodeList(data, row, callBack) {
	data.forEach(function(v, index) {
		if(v.id == row.pid) {
			try {
				var flag = true;
				if(!v.children) v.children = [];
				v.children.forEach(function(child, index) {
					try {
						if(child.id == row.id) flag = false;
						throw new Error("EndIterative");
					} catch(e) {
						if(e.message != 'EndIterative') throw e;
					}
				})
				if(flag) {
					v.children.push(row);
					typeof callBack == 'function' && callBack(true);
				};
				throw new Error("EndIterative");
			} catch(e) {
				if(e.message != 'EndIterative') throw e;
			}
		} else {
			if(v.children) addToTreeNodeList(v.children, row, callBack);
		}
	})
}

function dataURLtoBlob(base64) {
	var bstr = atob(base64),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while(n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new Blob([u8arr]);
}

function downloadFile(url, name = '未知文件') {
	var a = document.createElement("a")
	a.setAttribute("href", url)
	a.setAttribute("download", name)
	a.setAttribute("target", "_blank")
	let clickEvent = document.createEvent("MouseEvents");
	clickEvent.initEvent("click", true, true);
	a.dispatchEvent(clickEvent);
}

/**
 * TODO 获取图片尺寸
 * @param {Object} MyTest		files e.currentTarget.files[0]
 * @param {Object} calBack
 */
function readFileImg(MyTest, calBack) {
	var reader = new FileReader();
	reader.readAsDataURL(MyTest);
	reader.onload = function(e) {
		var data = e.target.result;
		//加载图片获取图片真实宽度和高度
		var image = new Image();
		image.src = data;
		image.onload = function() {
			var width = image.width;
			var height = image.height;
			var size = MyTest.size;
			var _opt = {
				width: width,
				height: height,
				size: size,
				src: data
			};
			calBack && calBack(_opt);
		};
	};
}

/**
 * 以url形式回显文件路径
 * @param file 本地添加的文件 input[type=file] file属性
 * @returns
 */
function getObjectURL(file) {
	var url = null;
	if(window.createObjectURL != undefined) { // basic
		url = window.createObjectURL(file);
	} else if(window.URL != undefined) { // mozilla(firefox)
		url = window.URL.createObjectURL(file);
	} else if(window.webkitURL != undefined) { // webkit or chrome
		url = window.webkitURL.createObjectURL(file);
	}
	return url;
}

/**
 * TODO img url 转换成 base64data
 * @param {Object} url img url
 * @param {Object} calBack calback
 */
function base64Image(url, calBack) {
	var img = document.createElement('img');
	img.src = url; //此处自己替换本地图片的地址
	img.onload = function() {
		var data = getBase64Image(img);
		//console.log(data);
		calBack && calBack(data);
		// 移除 img
		img.remove();
	}
}
/**
 * TODO img 转换成 base64data
 * @param {Object} img image节点
 */
function getBase64Image(img) {
	var canvas = document.createElement("canvas");
	canvas.width = img.width;
	canvas.height = img.height;
	var ctx = canvas.getContext("2d");
	ctx.drawImage(img, 0, 0, img.width, img.height);
	var dataURL = canvas.toDataURL("image/png");

	// 移除 canvas
	canvas.remove();

	return dataURL
	// return dataURL.replace("data:image/png;base64,", "");
}

/**
 * 导出Excel
 * @returns {void | PromiseLike<void> | Promise<void>}
 */
function exportExcel($outTable, filename = '1.xlsx', callback) {

	var xlsxParam = {
		raw: true
	} // 导出的内容只做解析，不进行格式转换
	/* 从表生成工作簿对象 */
	var wb = XLSX.utils.table_to_book($outTable, xlsxParam);
	/* 获取二进制字符串作为输出 */
	var wbout = XLSX.write(wb, {
		bookType: "xlsx",
		bookSST: true,
		type: "array"
	});
	try {
		FileSaver.saveAs(
			//Blob 对象表示一个不可变、原始数据的类文件对象。
			//Blob 表示的不一定是JavaScript原生格式的数据。
			//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
			//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
			new Blob([wbout], {
				type: "application/octet-stream"
			}),
			//设置导出文件名称
			filename
		);
	} catch(e) {
		if(typeof console !== "undefined") console.log(e, wbout);
	}
	callback && callback();
	return wbout;
}

/**
 * 全屏方法
 */
function isFullscreen() {
	return screenfull.isFullscreen;
}

/**
 * 全屏方法
 */
function fullscreen() {
	if(!screenfull.isEnabled) {
		Message({
			message: '您的浏览器无法使用全屏功能，请更换谷歌浏览器或者请手动点击F11按钮全屏展示！',
			type: 'error',
			showClose: true,
			dangerouslyUseHTMLString: true
		});
		return false;
	}
	if(!screenfull.isFullscreen) {
		screenfull.toggle();
	}
	return screenfull.isFullscreen;
}

/**
 * 全屏方法
 */
function exitFullscreen() {
	if(screenfull.isFullscreen) {
		screenfull.toggle();
	}
	return !screenfull.isFullscreen;
}

/**
 * 递归获取路由的所有路径
 * @param router 路由列表
 * @param pp 父级路径path parentPath
 * @return []string
 */
function getRouterPath(router, pp) {
	var arr = [];
	pp = pp || ''
	for(let r of router) {
		let path = r.path
		let children = r.children
		if(pp) {
			path = `${pp}/${path}`
		}
		// 如果有子元素，不添加父元素的路径
		if(children && children.length > 0) {
			arr = arr.concat(getRouterPath(children, path))
		} else {
			arr.push(path)
		}
	}
	return arr;
};

/**
 * TODO 访问地址 不传参时默认为当前窗口的url地址
 * @param {Object} url
 * @return urlJson {Object}		{
 * 		ohref: _href,hash: _hash,
 * 		data: {} //路径中 ?&=形式 传递的参数转换的json
 * }
 */
function getUrlJson(url) {
	var currUrl = url ? url : location.href;

	var paramKeyInd = currUrl.indexOf('?');
	var ohref = paramKeyInd > -1 ? currUrl.substring(0, paramKeyInd) : currUrl;

	var hashKeyInd = currUrl.lastIndexOf('#');
	var hash = hashKeyInd > -1 ? currUrl.substring(hashKeyInd + 1) : '';

	var urlJson = {};
	urlJson.ohref = ohref;
	urlJson.hash = hash;
	var data = {};
	var parameterLastInd = hashKeyInd > -1 ? hashKeyInd : currUrl.length;
	var parameterStr = paramKeyInd > -1 ? currUrl.substring(paramKeyInd + 1, parameterLastInd) : '';
	var parameterArr = parameterStr ? parameterStr.split("&") : [];
	parameterArr.forEach((value, index) => {
		var qtInd = value.indexOf("=");
		var _key = value.substring(0, qtInd);
		var _value = value.substring(qtInd + 1);
		data[decodeURIComponent(_key)] = decodeURIComponent(_value);
	});
	urlJson.data = data;
	return urlJson;
};

/**
 * TODO 获取XX年XX月最后一天的23:59:59
 * @param year 年份
 * @param month 月份（-1）
 * @return date 对象
 */
function getLastDayOfMonth(year, month) {
	// 创建一个日期对象，设置为下个月的第一天，然后减去1毫秒，这样可以得到上个月的最后一天
	const date = new Date(year, month + 1, 0);
	// 然后设置时间为23:59:59
	date.setHours(23, 59, 59, 999); // 设置为23:59:59.999
	return date;
};
/**
 * TODO 获取当月最后一天的23:59:59
 * @param ----
 * @return date 对象
 */
function getLastDayOfCurrentMonth() {
	// 获取当前年份和月份
	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth(); // 注意：月份是从0开始的，所以0代表1月，11代表12月

	// 获取当前月份的最后一天的23:59:59
	const lastDayOfMonth = getLastDayOfMonth(currentYear, currentMonth);
	return lastDayOfMonth;
};


// WEBPACK FOOTER //
// ./src/global/global-function.js